import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { StatusPageState } from './statuspage.state';
import { getters } from './statuspage.getters';
import { mutations } from './statuspage.mutations';
import { actions } from './statuspage.actions';

VueXHelper.setStoreModule(Module.STATUSPAGE, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new StatusPageState(),
  getters,
  mutations,
  actions,
};
